export * from './is-entitled-to-feature.evaluator';